import { render, staticRenderFns } from "./areaUserManage.vue?vue&type=template&id=6d666dc8&scoped=true"
import script from "./areaUserManage.vue?vue&type=script&lang=js"
export * from "./areaUserManage.vue?vue&type=script&lang=js"
import style0 from "./areaUserManage.vue?vue&type=style&index=0&id=6d666dc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d666dc8",
  null
  
)

export default component.exports